module.exports = __webpack_public_path__ + "img/join2-en.2a821efa.jpg";